import { configureStore } from '@reduxjs/toolkit';
import projectReducer from './slices/projectSlice';
import folderReducer from './slices/folderSlice';
import formPageReducer from './slices/formPageSlice';
import authReducer from './slices/authSlice';
import featureNotificationReducer from './slices/featureNotificationSlice';
import conversationReducer from './slices/conversationSlice';
import publicProjectReducer from './slices/publicProjectSlice';
import organizationReducer from './slices/organizationSlice';
import memberReducer from './slices/memberSlice';
import analyticsReducer from './slices/analyticsSlice';
import paymentReducer from './slices/paymentSlice';
import chatReducer from './slices/chatSlice';
import referralReducer from './slices/referralSlice';
import contactsReducer from './slices/contactsSlice';
import logicReducer from './slices/logicSlice';
import templateUIReducer from './slices/templateUISlice';
import blogReducer from './slices/blogSlice';

export const store = configureStore({
  reducer: {
    project: projectReducer,
    folders: folderReducer,
    formPage: formPageReducer,
    auth: authReducer,
    members: memberReducer,
    organization: organizationReducer,
    featureNotifications: featureNotificationReducer,
    conversation: conversationReducer,
    publicProject: publicProjectReducer,
    analytics: analyticsReducer,
    payment: paymentReducer,
    chat: chatReducer,
    referral: referralReducer,
    contacts: contactsReducer,
    logic: logicReducer,
    templateUI: templateUIReducer,
    blog: blogReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
